import { generateDigitSequence } from '../../helpers';
export const generateLegalEntityNumber = () => {
    return `${generateDigitSequence(8)}`;
};
export const commonData = {
    businessName: 'Redmont Studios',
    businessStreetName: 'Waterschapslaan',
    businessStreetNumber: ' 33',
    businessPostalCode: ' 1261JR',
    businessCity: 'Blaricum',
    businessStreetAddressLine2: 'Apt 1304',
    signatoryFirstName: 'John',
    signatoryLastName: 'Doe',
    signatoryDateOfBirth: '01-01-1980',
    signatoryNationality: 'US',
    isSignatoryShareAddress: true,
    signatoryPhoneNumber: '31243611123',
    businessCategoryId: '695',
    businessSubCategoryId: '720',
    businessLocationTypes: ['TEMPORARY_STORE', 'ONLINE_STORE'],
    businessFrequency: 'FEW_TIMES_A_MONTH',
    businessAverageTransaction: '50-500',
    businessIzettleShareOfTurnover: '20-80%',
    businessCurrentAnnualTurnover: '0-20000',
};
const personData = {
    firstName: 'Max',
    lastName: 'Mustermann',
    dateOfBirth: '12-12-1984',
    nationality: 'NL',
    streetName: 'Delftselaan',
    streetNumber: ' 34',
    postalCode: ' 2512RE',
    city: 'Den Haag',
    streetAddressLine2: '',
};
// Complete generators for each company type
const generateSelfEmployedData = (formContext) => (Object.assign(Object.assign(Object.assign({}, commonData), { businessType: 'SelfEmployed', businessLegalEntityNumber: generateLegalEntityNumber() }), (formContext.form.endsWith('1099K') ? { signatoryUnderUsaTaxLaw: false } : false)));
export const generateLimitedCompanyData = () => (Object.assign(Object.assign({}, commonData), { businessType: 'LimitedCompany', businessLegalEntityNumber: generateLegalEntityNumber(), legalPersons: {
        '495953a4-6706-4604-aa87-5373bb9b7bda': personData,
    }, roleDirectors: ['495953a4-6706-4604-aa87-5373bb9b7bda', 'SIGNATORY'], hasUBO: true, roleBeneficialOwners: ['SIGNATORY', '495953a4-6706-4604-aa87-5373bb9b7bda'] }));
export const generatePartnershipData = () => (Object.assign(Object.assign({}, commonData), { businessType: 'Partnership', businessLegalEntityNumber: generateLegalEntityNumber(), legalPersons: {
        'a023b5da-0dd9-4f82-95e4-d2983ba03d85': personData,
    }, rolePartners: ['SIGNATORY', 'a023b5da-0dd9-4f82-95e4-d2983ba03d85'], hasUBO: true, roleBeneficialOwners: ['SIGNATORY', 'a023b5da-0dd9-4f82-95e4-d2983ba03d85'] }));
export const generateNonProfitData = () => (Object.assign(Object.assign({}, commonData), { businessType: 'NonProfit', businessLegalEntityNumber: generateLegalEntityNumber(), legalPersons: {
        'a251e1e4-cfd8-41db-aa7b-60166375f746': personData,
    }, roleDirectors: ['a251e1e4-cfd8-41db-aa7b-60166375f746', 'SIGNATORY'], roleAlternativeOwners: ['SIGNATORY', 'a251e1e4-cfd8-41db-aa7b-60166375f746'] }));
export const NL = [
    {
        title: 'Self Employed',
        generateFunc: generateSelfEmployedData,
    },
    {
        title: 'Limited Company',
        generateFunc: generateLimitedCompanyData,
    },
    {
        title: 'Partnership',
        generateFunc: generatePartnershipData,
    },
    {
        title: 'NonProfit',
        generateFunc: generateNonProfitData,
    },
];
